import { TickList } from '@/app/components/TickList';
import Image from 'next/image';
import Link from 'next/link';

import { useMediaQuery } from '@material-ui/core';

import styles from './SalaryGuide.module.scss';
import { SalaryGuideForm } from './components/SalaryGuideForm';

type SalaryGuideProps = {
  fullPage?: boolean;
};

export default function SalaryGuide({ fullPage = false }: SalaryGuideProps) {
  const isDesktop = useMediaQuery('(min-width: 1140px)');

  return (
    <div className={styles.salaryGuide}>
      {isDesktop && fullPage === true && (
        <Image
          src="/assets/guide-book.svg"
          priority={false}
          alt=""
          aria-hidden
          width={149}
          height={198}
          style={{
            maxWidth: '100%',
            height: 'auto',
          }}
        />
      )}
      <div>
        <h2 className={styles.salaryGuideTitle}>
          FY27 Australian <span>Salary Guide</span>
        </h2>
        <p className={styles.subHeading}>
          Download our free FY27 guide and get the inside scoop on:
        </p>
        <TickList
          variant="small"
          items={[
            { key: 'earning', content: <>What doctors <span>are earning</span></> },
            { key: 'trends', content: <><span>Industry trends</span></> },
            { key: 'get-ahead', content: <>How to <span>get ahead in 2027</span></> },
          ]}
          itemRenderFunction={(item) => (
            <div key={item.key} className={styles.listItem}>
              {item.content}
            </div>
          )}
        />
        <Link
          prefetch={false}
          href="/doctors/resources"
          as="/doctors/resources"
          className={styles.downloadText}
        >
          Preview all available resources
        </Link>
      </div>
      <SalaryGuideForm />
    </div>
  );
}
